export const clinicInfo_LABELS = {
  clinicName: "Clinic Name",
  clinicAddress: "Clinic Address",
  bpSiteId: "BP Site ID",
  user: "User",
  emailId: "Email ID",
  status: " Subscription Status",
  totalLicenceKeys: "Total Licence Keys",
  noOfUsersAdded: "No.of Users Added",
};
